/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import MediaQuery from 'react-responsive';
import sliderImg1 from '../../asset/Home/Slider/slider1.png';
import sliderImg1Sp from '../../asset/Home/Slider/slider1sp.png';
import Terraforesta from '../../asset/Home/Slider/terraforesta.png';
// import sliderImg2 from '../../asset/Home/Slider/slider2.png';
// import sliderImg2Sp from '../../asset/Home/Slider/slider2sp.png';

const SliderTop = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // autoplay: true,
    speed: 5000,
    autoplaySpeed: 5000,
    // adaptiveHeight: true,
    lazyLoad: true,
  };
  return (
    <>
      <Slider {...settings}>
        <div>
          <div
            style={{
              position: 'relative',
            }}
          >
            <MediaQuery query="(min-width: 960px)">
              <img className="d-block" src={sliderImg1} style={{ width: '100%' }} alt="テラフォレスタ" />
              <div
                className="text"
                style={{
                  position: 'absolute',
                  top: '30%',
                  marginLeft: '15%',
                }}
              >
                <p
                  style={{
                    fontSize: '2rem',
                    letterSpacing: '1rem',
                    color: 'rgb(44,80,116)',
                    alignItems: 'center',
                    fontWeight: '600',
                    lineHeight: '2',
                  }}
                >
                  ウイルス･菌･悪臭ゼロの
                  <br />
                  安全・安心な空間の創造へ。
                </p>
                <a
                  className="d-block my-3"
                  href="https://terra-foresta.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: '50%' }}
                >
                  <img src={Terraforesta} style={{ width: '500px' }} alt="テラフォレスタ" />
                </a>
              </div>
            </MediaQuery>
            <MediaQuery query="(max-width: 959px) and (min-width: 540px)">
              <img className="d-block" src={sliderImg1Sp} style={{ width: '100%' }} alt="テラフォレスタ" />
              <div
                className="text"
                style={{
                  position: 'absolute',
                  top: '20%',
                  marginLeft: '5%',
                }}
              >
                <p
                  style={{
                    fontSize: '2rem',
                    letterSpacing: '0.5rem',
                    color: 'rgb(44,80,116)',
                    alignItems: 'center',
                    fontWeight: '600',
                    lineHeight: '2',
                  }}
                >
                  ウイルス･菌･悪臭ゼロの
                  <br />
                  安全・安心な空間の創造へ。
                </p>
                <a
                  className="d-block my-3"
                  href="https://terra-foresta.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: '60%' }}
                >
                  <img src={Terraforesta} style={{ width: '350px' }} alt="テラフォレスタ" />
                </a>
              </div>
            </MediaQuery>
            <MediaQuery query="(max-width: 539px)">
              <img className="d-block" src={sliderImg1Sp} style={{ width: '100%' }} alt="テラフォレスタ" />
              <div
                className="text"
                style={{
                  position: 'absolute',
                  top: '20%',
                  marginLeft: '5%',
                }}
              >
                <p
                  style={{
                    fontSize: '1rem',
                    letterSpacing: '0.5rem',
                    color: 'rgb(44,80,116)',
                    alignItems: 'center',
                    fontWeight: '600',
                    lineHeight: '2',
                  }}
                >
                  ウイルス･菌･悪臭ゼロの
                  <br />
                  安全・安心な空間の創造へ。
                </p>
                <a
                  className="d-block my-3"
                  href="https://terra-foresta.com/"
                  target="_blank"
                  rel="noreferrer"
                  style={{ width: '60%' }}
                >
                  <img src={Terraforesta} style={{ width: '200px' }} alt="テラフォレスタ" />
                </a>
              </div>
            </MediaQuery>
          </div>
        </div>
        {/* <div>
          <div
            style={{
              position: 'relative',
            }}
          >
            <MediaQuery query="(min-width: 960px)">
              <img className="d-block" src={sliderImg2} style={{ width: '100%' }} alt="EC 販売開始キャ ンペーン" />
              <div
                className="position-absolute"
                style={{
                  top: '0',
                  padding: '10% 10%',
                  width: '100%',
                  height: '100%',
                }}
              >
                <div
                  className="d-block h-100"
                  style={{
                    background: 'rgb(239,245,228)',
                    opacity: '0.9',
                    border: 'solid 5px rgb(60,117,101)',
                    padding: '1rem',
                  }}
                >
                  <div className="row">
                    <div className="col-12 col-md-6">
                      <div className="text-center">
                        <h2
                          style={{
                            color: 'rgb(60,117,101)',
                          }}
                        >
                          EC 販売開始
                          <br />
                          キャ ンペーン
                        </h2>
                        <h4>
                          7.14
                          {' '}
                          <mark style={{ background: 'black', color: 'white', fontSize: 'small' }}>水</mark>
                          {' '}
                          - 8.15
                          <mark style={{ background: 'black', color: 'white', fontSize: 'small' }}>日</mark>
                        </h4>
                      </div>

                    </div>
                    <div className="col-12 col-md-6">
                      <div className="text-center">
                        <h4
                          className="text-center"
                          style={{
                            color: 'rgb(60,117,101)',
                          }}
                        >
                          サイト内商品購入時に使える
                          <br />
                          クーポンをプレゼント
                        </h4>
                        <div
                          className="text-center p-3"
                          style={{ background: 'black' }}
                        >
                          <p className="text-center text-white">クーポンコード</p>
                          <p className="text-center bg-white text-black my-2 p-2">ABCDEFGH</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MediaQuery>
            <MediaQuery query="(max-width: 960px)">
              <img className="d-block" src={sliderImg2Sp} style={{ width: '100%' }} alt="EC 販売開始キャ ンペーン" />
              <div
                className="position-absolute"
                style={{
                  top: '0',
                  padding: '10% 10%',
                  width: '100%',
                  height: '100%',
                }}
              >
                <div
                  className="d-block py-5"
                  style={{
                    background: 'rgb(239,245,228)',
                    opacity: '0.9',
                    border: 'solid 5px rgb(60,117,101)',
                    padding: '0.5rem',
                  }}
                >
                  <div className="row">
                    <div className="col-12">
                      <div className="text-center pt-1">
                        <h3
                          style={{
                            color: 'rgb(60,117,101)',
                          }}
                        >
                          EC 販売開始
                          キャ ンペーン
                        </h3>
                        <h4>
                          7.14
                          {' '}
                          <mark style={{ background: 'black', color: 'white', fontSize: 'small' }}>水</mark>
                          {' '}
                          - 8.15
                          <mark style={{ background: 'black', color: 'white', fontSize: 'small' }}>日</mark>
                        </h4>
                      </div>
                    </div>
                    <br />
                    <div className="col-12">
                      <div className="text-center">
                        <br />
                        <h5
                          className="text-center"
                          style={{
                            color: 'rgb(60,117,101)',
                          }}
                        >
                          サイト内商品購入時に使える
                          <br />
                          クーポンをプレゼント
                        </h5>
                        <div
                          className="text-center p-2"
                          style={{ background: 'black' }}
                        >
                          <p className="text-center text-white">クーポンコード</p>
                          <p className="text-center bg-white text-black my-2 p-2">ABCDEFGH</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </MediaQuery>
          </div>
        </div> */}
      </Slider>
    </>
  );
};

export default SliderTop;
